import { push, ref } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetProformaInvoiceDataLocal from "./GetQuotationDataLocal";
import * as actionType from "../../../context/actions";
import GetQuotationDataLocal from "./GetQuotationDataLocal";

const AddQuotationDataInLocal = async (state, dispatch, invoiceData, userId) => {
    try {
        // Retrieve existing invoices from localStorage
        const existingData = JSON.parse(localStorage.getItem("LOCAL_QUOTATION")) || [];

        const formatItems = (rawItems) => {
            return rawItems.map(i => ({
                // amount: i?.amount?.toString() || "0.00",
                // billId: invoiceData?.id?.toString() || "",
                // companyId: invoiceData?.companyId?.toString() || "",
                // creationDate: new Date(invoiceData.creationDate).getTime().toString() || new Date().getTime().toString(),
                // isSalesReturnKey: "",
                // itemId: "",
                // name: i?.name || "",
                // price: i?.price?.toString() || "",
                // quantity: i?.quantity?.toString() || "",
                // subtitle: i.subtitle || "",
                // updateDate: new Date(invoiceData.creationDate).getTime().toString() || new Date().getTime().toString(),
                itemId: i?.itemId || "",
                itemAddedDate: new Date().getTime().toString() || "",
                price: i?.price?.toString() || "",
                quantity: i?.quantity?.toString() || "",
            }));
        };

        // New invoice data
        const newInvoice = {
            createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            createdById: state?.USERID || null,
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            updatedById: state?.USERID || null,
            uniqueID: (new Date().getTime() / 1000).toFixed(0),
            // address: invoiceData?.address?.toString() || "",
            // companyId: invoiceData?.companyId?.toString() || "",
            // creationDate: new Date(invoiceData.creationDate).getTime().toString() || new Date().getTime().toString(),
            // customInvoiceId: "",
            // customer: invoiceData?.customer?.toString() || "",
            // customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            // date: new Date(invoiceData?.creationDate).getTime().toString() || new Date().getTime().toString(),
            // discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            // discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            // dueDate: new Date(parseInt(invoiceData?.dateDue)).getTime().toString() || new Date().getTime().toString(),
            // email: invoiceData?.email.toString() || "",
            // gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            // pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            // pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            // gstPercetage: invoiceData?.gstPercentage?.toString() || "0",
            // id: invoiceData?.id?.toString() || "",
            // invoiceId: invoiceData?.invoiceId?.toString() || "",
            // isigst: invoiceData?.isigst?.toString() || "false",
            // items: formatItems(invoiceData?.items),
            // note: invoiceData?.note?.toString() || "",
            // paidFlagKey: invoiceData?.isPaid?.toString() || "false",
            // phone: invoiceData?.phone?.toString() || "",
            // totalAmount: invoiceData?.totalAmount?.toString() || "",
            // updateDate: new Date(invoiceData?.creationDate).getTime().toString() || new Date().getTime().toString(),
            // platform: "website",
            // version: 'website',
            companyId: invoiceData?.companyId?.toString() || "",
            creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            customInvoiceId: "",
            customerId: invoiceData?.customerId?.toString(),
            date: invoiceData?.date?.toString() || "",
            discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            dueDate: invoiceData?.dueDate?.toString() || new Date().getTime().toString(),
            gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            gstPercetage: invoiceData?.gstPercentage?.toString() || invoiceData?.gstPercetage?.toString() || "0",
            id: invoiceData?.id?.toString() || "",
            invoiceId: invoiceData?.invoiceId?.toString() || "",
            isigst: invoiceData?.isigst || invoiceData?.igst == true ? "true" : "false",
            note: invoiceData?.note?.toString() || "",
            paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            platform: "website",
            totalAmount: invoiceData?.totalAmount?.toString() || "",
            updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            version: 'website',
            items: formatItems(invoiceData?.items),
            currency: invoiceData?.currency?.toString() || "",
        };

        // Append new invoice to existing data
        existingData.push(newInvoice);

        // Save updated invoices back to localStorage
        localStorage.setItem("LOCAL_QUOTATION", JSON.stringify(existingData));

        // Fetch updated invoice data
        await GetQuotationDataLocal(state, dispatch);

        return { success: true, message: "New quotation added successfully!" };
    } catch (error) {
        return { success: false, message: error.message || error };
    }
};


export default AddQuotationDataInLocal;
